import { useLayoutEffect, useRef } from 'react';
import { gsap, revealUp, prefersReducedMotion } from '../lib/motion';

const METRICS = [
  { value: 20, suffix: '+', label: 'Years in the Trade' },
  { value: 300, suffix: '+', label: 'Units Renovated / Year' },
  { value: 12, suffix: '', label: 'Service Lines · One Vendor' },
  { value: 2021, suffix: '', label: 'Founded · Central Texas' },
];

export default function Metrics() {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctx = gsap.context(() => {
      revealUp('.mtr-reveal', el);

      gsap.utils.toArray<HTMLElement>('.mtr-num').forEach((num) => {
        const end = Number(num.dataset.value || 0);
        if (prefersReducedMotion()) {
          num.textContent = String(end);
          return;
        }
        const state = { v: end > 1000 ? end - 30 : 0 };
        gsap.to(state, {
          v: end,
          duration: 2.2,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 72%' },
          onUpdate: () => {
            num.textContent = String(Math.round(state.v));
          },
        });
      });
    }, el);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={ref} id="experience" className="relative bg-ink-950 py-32 md:py-44">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <p className="mtr-reveal eyebrow mb-20 text-center">Experience</p>

        <div className="grid grid-cols-1 gap-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {METRICS.map((m, i) => (
            <div
              key={m.label}
              className={`mtr-reveal text-center ${i > 0 ? 'lg:border-l lg:border-steel-100/10' : ''}`}
            >
              <div className="font-display text-7xl font-light leading-none text-steel-100 md:text-8xl">
                <span className="mtr-num" data-value={m.value}>0</span>
                <span className="text-gold-400">{m.suffix}</span>
              </div>
              <p className="mt-5 text-[11px] uppercase tracking-widest2 text-steel-400">{m.label}</p>
            </div>
          ))}
        </div>

        <p className="mtr-reveal mx-auto mt-24 max-w-lg text-center font-display text-2xl font-light italic leading-relaxed text-steel-300 md:text-3xl">
          “Trusted by owners, general contractors, and property managers across Texas.”
        </p>
      </div>
    </section>
  );
}
